import React, { Fragment } from 'react'
import { Box, Divider } from '@mui/material'
import { BulkDeleteProducer } from '@/producers/components/delete'
import BulkSireneSyncButton from '@/producers/components/BulkSireneSyncButton'
import SyncAllSireneButton from '@/producers/components/SyncAllSireneButton'

export default function ProducerBulkActions() {
    return (
        <Fragment>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <BulkSireneSyncButton />
                <SyncAllSireneButton />
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                <BulkDeleteProducer />
            </Box>
        </Fragment>
    )
}